import React from 'react'
import PropTypes from 'prop-types'
import BaseSelect from 'react-select'
import { useField } from '@morningtrain/react-fields'
import endsWith from 'lodash/endsWith'
import { toJS } from 'mobx'

function Select (props) {
  const field = useField(props)

  const resolvedValue = []

  const { options } = field

  if (options.length > 0) {
    const jsValue = toJS(field.value)
    const comparisonValues = Array.isArray(jsValue) ? jsValue : [jsValue]

    options.forEach(function ({ value, label }) {
      if (comparisonValues.length > 0) {
        comparisonValues.forEach(compValue => {
          if (typeof compValue === 'object' && compValue !== null && compValue.value) {
            compValue = compValue.value
          }
          if (`${compValue}` === `${value}`) {
            resolvedValue.push({ value, label })
          }
        })
      }
    })
  }

  const handleChange = (nextValue) => {
    const realValue = (!!nextValue && typeof nextValue.value !== 'undefined') ? nextValue.value : nextValue
    field.onChange(realValue)
  }

  const handleSelectAll = React.useCallback(() => {
    const values = options.map(({ value }) => value)
    handleChange(values)
  }, [options])

  const finalOptions = [...options]

  if (props.placeholder && !props.multiple) {
    finalOptions.unshift({ value: null, label: props.placeholder })
  }

  const forwardProps = {
    ...props,
    id: field.id,
    options: finalOptions,
    onChange: handleChange,
    placeholder: props.placeholder,
    closeMenuOnSelect: (props.closeMenuOnSelect !== null) ? (props.closeMenuOnSelect) : (props.multiple === false)
  }

  if (props.multiple === true) {
    forwardProps.isMulti = true
    forwardProps.name = endsWith(field.name, '[]') ? field.name : field.name + '[]'
    forwardProps.value = resolvedValue
  } else {
    forwardProps.name = field.name
    forwardProps.value = resolvedValue.length > 0 ? resolvedValue[0] : null
  }

  return field.wrap(() => (
    <>
      {props.withSelectAll && (
        <div className='advanced-select-select-all' onClick={handleSelectAll}>
          {props.selectAllLabel || 'Select all'}
        </div>
      )}
      <BaseSelect {...forwardProps} />
    </>
  ))
}

Select.defaultProps = {
  ...useField.defaultProps,
  styles: {},
  placeholder: '',
  multiple: false,
  selectAllLabel: null,
  withSelectAll: false,
  closeMenuOnSelect: null
}

Select.propTypes = {
  ...useField.propTypes,
  styles: PropTypes.object,
  placeholder: PropTypes.string,
  multiple: PropTypes.bool,
  selectAllLabel: PropTypes.node,
  withSelectAll: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool
}

export default Select
